import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for Confluence whiteboard diagramming.
 */

/**
 * Properties for the Confluence whiteboard diagramming command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by a bridge API client to start a Confluence whiteboard diagramming.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to start a Confluence whiteboard diagramming.
 */
export var ConfluenceWhiteboardDiagrammingCommand = createCommand('confluence-whiteboard-diagramming-command');